var _path, _g, _path2, _g2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBladder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_20531",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 11,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.27 3H3V21.5H13.27V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_20531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5.7207L6.43001 8.4107C6.52001 8.5007 6.58001 8.6307 6.59001 8.7707L6.69 10.8507C6.77 12.5407 7.38 13.2807 8.41 14.1707L10.98 16.2007C11.82 16.8607 12.28 17.7807 12.26 18.7407L12.22 20.7707",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4196 5.78024C11.3296 5.69024 8.7196 6.59023 8.7196 6.59023L5.84961 3.74023",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2071_20531",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 3,
    width: 11,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5395 3H13.2695V21.5H23.5395V3Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2071_20531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7997 5.7207L20.1197 8.4107C20.0297 8.5007 19.9697 8.6307 19.9597 8.7707L19.8597 10.8507C19.7797 12.5407 19.1697 13.2807 18.1397 14.1707L15.5697 16.2007C14.7297 16.8607 14.2697 17.7807 14.2897 18.7407L14.3297 20.7707",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1191 5.78024C15.2091 5.69024 17.8191 6.59023 17.8191 6.59023L20.6891 3.74023",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 12.3505C11.3292 12.0005 11.8192 11.4705 12.7592 12.1605C12.8792 12.2505 13.7992 12.6405 14.3792 12.4905C15.4092 12.2205 16.4492 12.0205 16.4492 12.0205",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBladder);
export default __webpack_public_path__ + "static/media/Bladder.b5bf6bc5f98548a91c06ec8901228096.svg";
export { ForwardRef as ReactComponent };